module.exports = __webpack_public_path__ + "assets/img/1_911_big.39cd9364.jpg";